<script setup lang="ts">
import type { NavigationMenuItem } from "@nuxt/ui";

const _route = useRoute();

const open = ref(false);

const links = [
  // Ana işlevler
  [{
    label: "Dashboard",
    icon: "i-lucide-layout-dashboard",
    to: "/",
    onSelect: () => {
      open.value = false;
    }
  }, {
    label: "Customers",
    icon: "i-lucide-users",
    to: "/customers",
    onSelect: () => {
      open.value = false;
    }
  }, {
    label: "Orders",
    icon: "i-lucide-soup",
    to: "/orders",
    onSelect: () => {
      open.value = false;
    }
  }],
  // Personel
  [{
    label: "Staff",
    icon: "i-lucide-hand-platter",
    to: "/management/employees",
    onSelect: () => {
      open.value = false;
    }
  }, {
    label: "Roles",
    icon: "i-lucide-shield-check",
    to: "/management/roles",
    onSelect: () => {
      open.value = false;
    }
  }],
  // Yönetim
  [{
    label: "Management",
    to: "/management",
    icon: "i-lucide-settings",
    defaultOpen: true,
    type: "trigger",
    children: [
      {
        label: "Tip Calculator",
        icon: "i-lucide-calculator",
        to: "/tip-calculator",
        onSelect: () => {
          open.value = false;
        }
      }, {
        label: "Data Import",
        icon: "i-lucide-database",
        to: "/management/import",
        onSelect: () => {
          open.value = false;
        }
      }, {
        label: "Branches",
        icon: "i-lucide-store",
        to: "/management/locations",
        disabled: true,
        onSelect: () => {
          open.value = false;
        }
      }, {
        label: "Scenarios",
        icon: "i-lucide-workflow",
        to: "/management/scenarios",
        disabled: true,
        onSelect: () => {
          open.value = false;
        }
      }, {
        label: "Shift Planner",
        icon: "i-lucide-calendar-clock",
        to: "/shift-management",
        disabled: true,
        onSelect: () => {
          open.value = false;
        }
      }]
  }]
] satisfies NavigationMenuItem[][];

// Command-K search groups
const groups = computed(() => [{
  id: "links",
  label: "Go to",
  items: links.flat()
}]);
</script>

<template>
  <UDashboardGroup unit="rem">
    <UDashboardSidebar
      id="default"
      v-model:open="open"
      collapsible
      resizable
      class="bg-elevated/25"
      :ui="{ footer: 'lg:border-t lg:border-default' }"
    >


      <template #header="{ collapsed }">
        <SidebarBranchMenu :collapsed="collapsed" />
      </template>

      <template #default="{ collapsed }">

        <UDashboardSearchButton :collapsed="collapsed" class="bg-transparent ring-default" />

        <UNavigationMenu
          :collapsed="collapsed"
          :items="links"
          orientation="vertical"
          tooltip
          popover
        />
      </template>

      <template #footer="{ collapsed }">
        <SidebarUserMenu :collapsed="collapsed" />
      </template>
    </UDashboardSidebar>

    <UDashboardSearch :groups="groups" />

    <slot />

    <!-- Global Error Modal -->
    <ErrorModal />
  </UDashboardGroup>
</template>
